<template lang="pug">
  v-container
    illustration-state(
      :illustration="illustration"
      :height="300"
      title="Nous vous remercions pour votre générosité !"
      body="Vous allez être redirigé vers l'association soutenue...")
    v-row.justify-center
      v-col.text-center
        v-progress-circular(indeterminate)
</template>

<script>
import { page } from '@iez/core'
import IllustrationState from '@iez/components/illustration-state/'
import illustration from '@iez/illustrations/Appreciation'
import router from '@iez/core/router/'

const route = {
  name: `DonateToAssociationSuccess`,
  path: `/donate-to-association-success`
}

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    page.topBar.set({
      title: `Merci`
    })

    setTimeout(
      () => {
        router.back()
        router.back()
        router.back()
      },
      3000
    )

    return {
      illustration
    }
  }
}
</script>
